module.exports = __webpack_public_path__ + "img/people.42834284.webp";